import React from 'react'
import PropTypes from 'prop-types'
import Box from '@material-ui/core/Box'
import { useCoachProfileInColumn } from '@lib/pga-coach/coach-profile-layout'
import useStyles from './coach-tools-row.styles'

/**
 * Compact unlabeled pill chips for flagged About specialized skills.
 * Embedded profile placement follows the rendered bio and its read-more
 * control — no section heading. Callers supply `ariaLabel` for the
 * region name. Visual treatment matches shop listing /
 * `/golf-lessons` tags (`blue.light25` / `#8a94a3`).
 */
function CoachProfileChipRow({
  items = [],
  ariaLabel,
  headingId,
  embedded = false,
}) {
  const inColumn = useCoachProfileInColumn()
  const compact = embedded || inColumn
  const styles = useStyles({ inColumn: compact })

  if (!Array.isArray(items) || items.length === 0) return null

  const rootClassName = compact ? styles.rootEmbedded : styles.root
  const innerClassName = compact
    ? `${styles.inner} ${styles.innerEmbedded}`
    : styles.inner
  const chipListClassName = compact
    ? `${styles.chipList} ${styles.chipListEmbedded}`
    : styles.chipList
  const chipClassName = compact
    ? `${styles.chip} ${styles.chipEmbedded}`
    : styles.chip

  return (
    <Box
      component="section"
      className={rootClassName}
      id={headingId}
      aria-label={ariaLabel}
    >
      <Box className={innerClassName}>
        <Box component="ul" className={chipListClassName}>
          {items.map((item) => (
            <Box component="li" key={item} className={chipClassName}>
              {item}
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  )
}

CoachProfileChipRow.propTypes = {
  items: PropTypes.arrayOf(PropTypes.string),
  ariaLabel: PropTypes.string.isRequired,
  headingId: PropTypes.string.isRequired,
  /** When true, renders inside the About bio (no full-bleed band chrome). */
  embedded: PropTypes.bool,
}

export default CoachProfileChipRow
